import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx-js-style";
import "../css/mail.css";
import { sendFormDataMail } from "../services/Mail_service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEnvelope,FaCheckCircle} from "react-icons/fa";
import { UserModel } from "../models/UserModel";
import { getAllClientByUsers } from "../services/Login_service";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Style pour l'éditeur
import saveAs from "file-saver";
import {
  faPlus,
  faTrash,
  faPaperclip,
  faImage,
  faTimes,
  faFileExcel,
  faDownload,
  faFile,
  faBellSlash,
  faExclamationTriangle,
  faEraser,
  faHistory,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InputRef } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { Tag } from "antd";
import { useEmailValidation } from "../hooks/useEmailValidation";
import { Modal, Button } from "react-bootstrap";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import juice from "juice";
import SummernoteEditor from "./SummernoteEditor";
import { InfoKBISService} from "../services/InfoKBIS_service";




interface EditorProps {
  placeholder: string;
}


interface RecipientDetails {
  name?: string;
  adresse?: string;
  codePostal?: string;
  ville?: string;
  telephone?: string;
  profession?: string;
  dirigeant?: string;
  siret?: string;
  commentaires?: string;
}

interface EmailOption {
  value: string;
  label: string;
  details?: RecipientDetails;
}

function EnvoyerMail() {
  const authUser = useSelector((state: RootState) => state.user.user);
  const [filteredClient, setFilteredClient] = useState<UserModel[]>([]);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState<boolean>(false);

  const [emailList, setEmailList] = useState<string[]>([]);
  const [showEmailTable, setShowEmailTable] = useState(false);
  const [showInputField, setShowInputField] = useState(true);
  const [importType, setImportType] = useState<"clients" | "file" | null>(null);
  const [editorHtml, setEditorHtml] = useState<string>("");
  const [singleEmail, setSingleEmail] = useState("");
  const [emailData, setEmailData] = useState({
    name: "",
    object: "",
    sender: "",
    bcc: [],
  });
  const [emailListLoading, setEmailListLoading] = useState(false);
  const [attachments, setAttachments] = useState<{
    attachments: File[];
    coverImage?: {
      file: File;
      preview: string;
    };
  }>({
    attachments: [],
    coverImage: undefined,
  }); // State to store selected files
  const htmlWithInlineStyles = juice(editorHtml);

  const [allowUnsubscribe, setAllowUnsubscribe] = useState(true);
  const [showRgpdWarning, setShowRgpdWarning] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [sortKey, setSortKey] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const htmlInputRef = useRef<HTMLInputElement | null>(null);

  // Ajoutez ces états après les autres useState
const [headerColor, setHeaderColor] = useState<string>("#2A919D");
const [lastUsedColor, setLastUsedColor] = useState<string>("#2A919D");
const [importedHtml, setImportedHtml] = useState<{
  file?: File;
  content?: string;
  name?: string;
}>({});

// Ajoutez cet useEffect après les autres useEffect
useEffect(() => {
  const savedColor = localStorage.getItem("lastHeaderColor");
  if (savedColor) {
    setHeaderColor(savedColor);
    setLastUsedColor(savedColor);
  }
}, []);

// Ajoutez ces fonctions après les autres fonctions
const handleColorChange = (newColor: string) => {
  setHeaderColor(newColor);
  setLastUsedColor(newColor);
  localStorage.setItem("lastHeaderColor", newColor);
};

const handleHtmlImport = (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target?.result) {
        const content = event.target.result as string;
        setEditorHtml(content);
        setImportedHtml({
          file: file,
          content: content,
          name: file.name
        });
        toast.success("Contenu HTML importé avec succès");
      }
    };
    reader.readAsText(file, "UTF-8");
  }
};

const handleRemoveHtml = () => {
  setEditorHtml("");
  setImportedHtml({});
  if (htmlInputRef.current) {
    htmlInputRef.current.value = "";
  }
  toast.info("Fichier HTML supprimé");
};


  const sortBy = (key: "name" | "firstname" | "email" | "createdAt") => {
    const sorted = [...filteredClient].sort((a, b) => {
      if (key === "createdAt") {
        return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
      }

      return a[key].localeCompare(b[key]);
    });
    setFilteredClient(sorted);
    setSortKey(key);
  };

  useEffect(() => {
    if (showRgpdWarning) {
      setAllowUnsubscribe(true);
    }
  }, [showRgpdWarning]);

  useEffect(() => {
    const importedRecipients = localStorage.getItem("importedRecipients");
    if (importedRecipients) {
      try {
        const recipientsArray = JSON.parse(importedRecipients);
        
        const newOptions = recipientsArray.map((email: string) => ({
          label: email,
          value: email,
        }));
        
        setSelectedEmailOptions((prev) => {
          const existingEmails = prev.map(opt => opt.value);
          const uniqueNew = newOptions.filter(
            (opt: { value: string; label: string }) => !existingEmails.includes(opt.value)
          );
          return [...prev, ...uniqueNew];
        });
        
        localStorage.removeItem("importedRecipients");
        
        // Notification
        toast.info(`${recipientsArray.length} destinataire(s) importé(s)`, {
          position: "top-right",
          autoClose: 3000,
        });
      } catch (error) {
        console.error("Erreur lors de l'import des destinataires:", error);
        toast.error("Erreur lors de l'import des destinataires");
      }
    }
  }, []); 

//   useEffect(() => {
//   getListUsers();
//   console.log("getListUsers appelé");
// }, []);


  const handleAttachmentChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (files) {
      setAttachments((prev) => ({
        ...prev,
        attachments: [...prev.attachments, ...Array.from(files)],
      }));
    }
  };

  const handleRemoveAttachment = (index: number) => {
    setAttachments((prev) => ({
      ...prev,
      attachments: prev.attachments.filter((_, i) => i !== index),
    })); // Remove file by index
  };

  const handleCoverImageChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (files && files[0] && files[0].type.startsWith("image/")) {
      console.log("pass= ", files[0].type.startsWith("image/"));

      const file = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target) {
          setAttachments((prev) => ({
            ...prev,
            coverImage: {
              file: file,
              preview: e.target?.result as string,
            },
          }));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveCoverImage = () => {
    setAttachments((prev) => ({ ...prev, coverImage: undefined }));
  };

  const handleChange = (html: string) => {
    setEditorHtml(html);
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [
        "link",
        // 'image',
        // 'video'
      ],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];
  const [selectedEmails, setSelectedEmails] = useState<Set<string>>(new Set());
const [selectedEmailOptions, setSelectedEmailOptions] = useState<EmailOption[]>([]);


  const [inputEmail, setInputEmail] = useState<string>();

  // hook
  const { isValidEmail } = useEmailValidation();

  const attachmentInputRef = useRef<HTMLInputElement | null>(null); // Ref for the attachments file input
  const coverImageInputRef = useRef<HTMLInputElement | null>(null); // Ref for the cover image file input
  const emailInputRef = useRef<HTMLInputElement | null>(null); // Ref for the email input
  const [text, setText] = useState("");
  const handleSelectChangeEmail = (
    selected: { value: string; label: string }[]
  ) => {
    setSelectedEmailOptions(selected);
  };

  const handleInputKeyDownEmail = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    const inputValue = (event.target as HTMLInputElement).value.trim();
    setInputEmail(inputValue);
    setEmailListLoading(true);
    if ((event.key === " " || event.key === "Enter") && inputValue) {
      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(inputValue)) {
        console.error("Invalid email format");
        return;
      }

      // Add the email to the selected list
      if (
        !selectedEmailOptions?.map((email) => email.value).includes(inputValue)
      ) {
        setSelectedEmailOptions((prev) => [
          ...prev,
          { label: inputValue.trim(), value: inputValue.trim() },
        ]);
      }

      // Clear the input field
      (event.target as HTMLInputElement).value = "";
      setEmailListLoading(false);
      if (emailInputRef.current) {
        emailInputRef.current.value = ""; // Clear the input field
      }
      setInputEmail(undefined);
    }
    setEmailListLoading(false);
  };

  const handleClickValid = () => {
    const emailValue = emailInputRef.current?.value;
    // Add the email to the selected list
    if (
      emailValue &&
      !selectedEmailOptions?.map((email) => email.value).includes(emailValue)
    ) {
      setSelectedEmailOptions((prev) => [
        ...prev,
        { label: emailValue.trim(), value: emailValue.trim() },
      ]);
      if (emailInputRef.current) {
        emailInputRef.current.value = ""; // Clear the input field
      }
    }
  };

  const handleClientCheckboxChange = (email: string) => {
    setSelectedEmails((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(email)) {
        newSelected.delete(email);
      } else {
        newSelected.add(email);
      }
      return newSelected;
    });
  };

  const getListUsers = async () => {
    setLoading(true);
    const userId = localStorage.getItem("userId");

    if (userId) {
      try {
        const clients = await getAllClientByUsers(parseInt(userId));

        const filteredClients = clients.filter(
          (client) => client.status !== "anonymous"
        );

        setFilteredClient(filteredClients);

        const emails = filteredClients.map((client) => client.email);

        setShowEmailTable(true);
        setShowInputField(false);
        setImportType("clients");
      } catch (error) {
        console.error("Erreur lors de la récupération des clients", error);
        toast.error("Erreur lors de la récupération des clients.");
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };


const handleDownloadExample = () => {
  const exampleData = [
    [
      "Email",
      "Nom & Prénom(s) (Facultatif)",
      "Adresse (Facultatif)",
      "Code Postal (Facultatif)",
      "Ville (Facultatif)",
      "Téléphone (Facultatif)",
      "Profession (Facultatif)",
      "Dirigeant (Facultatif)",
      "SIRET (Facultatif)",
      "Commentaires (Facultatif)"
    ],
   
    [
      "exemple1@mail.com",
      "Dupont Jean",
      "12 Rue de Paris",
      "75001",
      "Paris",
      "0123456789",
      "Avocat",
       "Jean Dupont",
      "12345678900012",
      "Ici votre commentaire"

     
    ],
    [
      "exemple2@mail.com",
      "Martin Claire",
      "34 Avenue Victor Hugo",
      "69003",
      "Lyon",
      "0987654321",
      " Entrepreneur",
      "Claire Martin",
      "98765432100034",
      "Ici votre commentaire"
   
    ],
    [
      "exemple3@mail.com",
      "Durand Paul",
      "56 Boulevard Saint-Germain",
      "75005",
      "Paris",
      "0147852369",
      "Médecin",
      "Paul Durand",
      "45678912300056",
      "Ici votre commentaire"
    ],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(exampleData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clients");

  const worksheetRef = worksheet["!ref"];
  if (worksheetRef) {
    const headerRange = XLSX.utils.decode_range(worksheetRef);
    for (let C = headerRange.s.c; C <= headerRange.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (worksheet[cellAddress]) {
        worksheet[cellAddress].s = {
          fill: { patternType: "solid", fgColor: { rgb: "4BB0C0" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }
    }
  }

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, "clients_modele.xlsx");
};

// Ajouter cette fonction dans votre composant
const handleRemoveAllRecipients = () => {
  if (selectedEmailOptions.length === 0) {
    toast.warning("Aucun destinataire à supprimer");
    return;
  }

  if (window.confirm(`Êtes-vous sûr de vouloir supprimer tous les ${selectedEmailOptions.length} destinataire(s) ?`)) {
    setSelectedEmailOptions([]);
    setSelectedEmails(new Set()); 
    toast.success("Tous les destinataires ont été supprimés");
  }
};


  const handleAddSingleEmail = () => {
    if (singleEmail && !selectedEmails.has(singleEmail)) {
      setSelectedEmails((prevSelected) =>
        new Set(prevSelected).add(singleEmail)
      );
      // Réinitialiser  de tous les champs
      setSingleEmail("");
      toast.success("Adresse e-mail ajoutée avec succès.");

    } else {
      toast.error("L'adresse e-mail est déjà dans la liste ou invalide.");
    }
  };

  const handleImportFileClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
    setShowEmailTable(false);
    setShowInputField(true);
    setImportType("file");
  };

const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const file = event.target.files?.[0];
  if (!file) return;

  setFileName(file.name);

  const reader = new FileReader();
  reader.onload = (e: ProgressEvent<FileReader>) => {
    if (!e.target?.result) return;

    try {
      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const json: any[] = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

      // console.log("Contenu du fichier Excel :", json);

      if (!json[0]?.Email) {
        toast.error("Le fichier doit contenir au moins l'en-tête : Email.");
        return;
      }

      const newEmailOptions: EmailOption[] = json.map((row: any) => ({
        label: row.Email,
        value: row.Email,
        details: {
          name: row["Nom & Prénom(s) (Facultatif)"] || "",
          adresse: row["Adresse (Facultatif)"] || "",
          codePostal: row["Code Postal (Facultatif)"] || "",
          ville: row["Ville (Facultatif)"] || "",
          telephone: row["Téléphone (Facultatif)"] || "",
          profession: row["Profession (Facultatif)"] || "",
          dirigeant: row["Dirigeant (Facultatif)"] || "",
          siret: row["SIRET (Facultatif)"] || "",
          commentaires: row["Commentaires (Facultatif)"] || "",
        },
      }));

      setSelectedEmailOptions((prev) => [...prev, ...newEmailOptions]);

      toast.success(`${json.length} destinataire(s) importé(s) avec succès.`);
    } catch (error) {
      console.error("Erreur lors de la lecture du fichier:", error);
      toast.error("Erreur lors de la lecture du fichier Excel.");
    }
  };

  reader.readAsArrayBuffer(file);
};




  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setEmailData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    setAllowUnsubscribe(checked);
    if (checked) {
      toast.info("Le destinataire pourra se désabonner via le mail.");
    } else {
      toast.warn("Le destinataire ne pourra pas se désabonner via le mail.");
    }
  };

const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  if (!emailData.object.trim()) {
    toast.error("L'objet est requis.");
    return;
  }

  if (!selectedEmailOptions || selectedEmailOptions.length === 0) {
    toast.error("Veuillez ajouter au moins un destinataire.");
    return;
  }

  setLoading(true);

  try {
    
for (const recipient of selectedEmailOptions) {
  const { value: email, details } = recipient;
  const safeDetails: RecipientDetails = details || {};

  console.log("Details du destinataire :", safeDetails);


  const formData = new FormData();
  formData.append("object", emailData.object);
  // formData.append("message", juice(personalizedHtml)
  formData.append("sender", authUser?.email as string);
  formData.append("bcc", JSON.stringify([email]));
  formData.append("isClient", "true");
  formData.append("userId", `${authUser?.id}`);
  formData.append("allowUnsubscribe", allowUnsubscribe ? "true" : "false");
  formData.append("details", JSON.stringify(safeDetails)); 
  formData.append("message", htmlWithInlineStyles);
  formData.append("headerColor", headerColor);



  attachments.attachments.forEach((file) => formData.append("attachments", file));
  if (attachments.coverImage) formData.append("coverImage", attachments.coverImage.file);

  await sendFormDataMail(formData);
}


    toast.success("Emails envoyés avec succès !");
    setEmailData({ bcc: [], name: "", object: "", sender: "" });
    setEditorHtml("");
    setAttachments({ attachments: [], coverImage: undefined });
    setSelectedEmailOptions([]);
    setInputEmail(undefined);
    setShowEmailTable(false);
    setFilteredClient([]);
    setImportType(null);

  } catch (error: any) {
    console.error("Erreur lors de l'envoi des emails :", error);
    toast.error(error.message || "Erreur lors de l'envoi des emails");
  } finally {
    setLoading(false);
  }
};


  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (selectedEmails) {
      const emailsSelected = Array.from(selectedEmails);
      const missingEmails = emailsSelected.filter(
        (email) =>
          !selectedEmailOptions.some((option) => option.label === email)
      );
      // Map the missing emails to the required format and add them to selectedEmailOptions
      const newOptions = missingEmails.map((email) => ({
        label: email,
        value: email,
      }));
      setSelectedEmailOptions((prev: { value: string; label: string }[]) => [
        ...prev,
        ...newOptions,
      ]);
    }
  }, [selectedEmails]);
  return (
    <>
      {/* Modal RGPD désabonnement */}
      <Modal
        show={showRgpdWarning}
        onHide={() => setShowRgpdWarning(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" style={{color:'#eb8635'}}/>
            Avertissement RGPD
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: "18px" }}>
            Permettre le désabonnement peut contrevenir aux règles du RGPD et entraîner des répercussions juridiques.
          </p>
          <div className="d-flex align-items-center border rounded p-2 mt-3">
            <input
              className="form-check-input me-2"
              type="checkbox"
              id="unsubscribeCheckModal"
              checked={allowUnsubscribe}
              onChange={handleCheckboxChange}
            />
            <label className="form-check-label mb-0" htmlFor="unsubscribeCheckModal">
              Permettre le désabonnement
            </label>
          </div>
          <div className="mt-3">
            <a
              href="https://annonce-legale-officielle.fr/politique-de-protection/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline", color: "#4BB0C0" }}
            >
              Politique de protection des données et Newsletters
            </a>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRgpdWarning(false)}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>
      <form
        className="mt-3"
        onSubmit={handleSubmit}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
          }
        }}
      >


        {showEmailTable && (
          <div className="ImportEmailTable">
            <div className="filters mb-3 d-flex align-items-center gap-3 flex-wrap">
              <input
                type="text"
                placeholder="Rechercher par nom, prénom ou email"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="form-control"
                style={{ width: "250px" }}
              />


              <div className="d-flex align-items-center gap-2">
                <DatePicker
                  selected={startDate ?? undefined}
                  onChange={(date) => setStartDate(date)}
                  placeholderText="Date de début"
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                />

                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  placeholderText="Date de fin"
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                  minDate={startDate ? startDate : undefined}
                />
              </div>



              <div className="position-relative">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  ☰  Trier par
                </button>

                {isDropdownOpen && (
                  <div
                    className="dropdown-menu show"
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      zIndex: 1000,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      minWidth: "200px",
                      boxShadow: "0 2px 6px rgba(150, 243, 252, 0.1)",
                    }}
                  >
                    <button type="button" className="dropdown-item w-100 text-start px-3 py-2" onClick={() => sortBy("name")}>
                      Nom
                    </button>
                    <button type="button" className="dropdown-item w-100 text-start px-3 py-2" onClick={() => sortBy("firstname")}>
                      Prénom
                    </button>
                    <button type="button" className="dropdown-item w-100 text-start px-3 py-2" onClick={() => sortBy("email")}>
                      Email
                    </button>
                    <button type="button" className="dropdown-item w-100 text-start px-3 py-2" onClick={() => sortBy("createdAt")}>
                      Date d'inscription
                    </button>
                  </div>
                )}
              </div>
            </div>

            <div className="email-table-container mb-3">
              <table className="table">
                <thead>
                  <tr>
                    <th>Sélectionner</th>
                    <th>Nom & Prénoms</th>
                    <th>Date d'inscription</th>
                    <th className="email-header">
                      Destinataire ({filteredClient.length})
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredClient
                    .filter((client) => {
                      const search = searchTerm.toLowerCase();
                      const fullName = `${client.name} ${client.firstname}`.toLowerCase();
                      const email = client.email.toLowerCase();
                      const matchesSearch =
                        fullName.includes(search) || email.includes(search);

                      const clientDate = new Date(client.createdAt);
                      const matchesDate =
                        (!startDate || clientDate >= startDate) &&
                        (!endDate || clientDate <= endDate);

                      return matchesSearch && matchesDate;
                    })
                    .map((client) => (
                      <tr key={client.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedEmails.has(client.email)}
                            onChange={() =>
                              handleClientCheckboxChange(client.email)
                            }
                          />
                        </td>
                        <td>
                          {client.name} {client.firstname}
                        </td>
                        <td>
                          {format(new Date(client.createdAt), "dd/MM/yyyy")}
                        </td>
                        <td>
                          <div className="user__info">
                            <FaEnvelope className="email-icon" />
                            <div className="mx-2">
                              <div className="user__email">{client.email}</div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}



        {showInputField && importType === "file" && (
          <div className="mb-3">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                id="destinataire"
                placeholder="Destinataire"
                value={fileName}
                readOnly
              />
            </div>
          </div>
        )}

      <div className="import-actions d-flex flex-wrap mb-3">
        <div className="action-item">
          <Tag
            className="py-2 cursor-pointer w-100"
            onClick={getListUsers}
            style={{ backgroundColor: "#2A919D", color: "white" }}
          >
            <FontAwesomeIcon icon={faFile} style={{ marginRight: "10px" }} />
            Importer les emails des Clients
          </Tag>
        </div>

        <div className="action-item">
          <Tag
            className="py-2 cursor-pointer w-100"
            onClick={() => fileInputRef.current?.click()}
            style={{ backgroundColor: "#2A919D", color: "white" }}
          >
            <FontAwesomeIcon icon={faFileExcel} style={{ marginRight: "10px" }} />
            Importer un fichier Excel
          </Tag>
          <input
            type="file"
            ref={fileInputRef}
            accept=".xlsx, .xls"
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </div>

        <div className="action-item">
          <Tag
            className="py-2 cursor-pointer w-100"
            onClick={handleDownloadExample}
            style={{ backgroundColor: "#2A919D", color: "white" }}
          >
            <FontAwesomeIcon icon={faDownload} style={{ marginRight: "10px" }} />
            Télécharger le modèle d'import Excel
          </Tag>
        </div>
      </div>



        <div className="row form-row">
          <div className="col-md-12">
            <div className="mb-3">
              <label htmlFor="objet">Objet</label>
              <input
                type="text"
                className="form-control"
                id="object"
                value={emailData.object}
                onChange={handleInputChange}
              />
            </div>
            <div className="mb-3">
              <div className="d-flex flex-column gap-2">
                <div className="w-100">
                  <label htmlFor="email">Saisir email destinataire</label>
                  <input
                    ref={emailInputRef}
                    className="form-control"
                    type="text"
                    onKeyDown={handleInputKeyDownEmail}
                    onBlur={() => {
                      if (!emailInputRef.current) return;

                      const emailValue = emailInputRef.current.value.trim();

                      if (emailValue && isValidEmail(emailValue)) {
                        setSelectedEmailOptions(prev => [
                          ...prev,
                          { value: emailValue, label: emailValue }
                        ]);

                        emailInputRef.current.value = ""; 
                      }
                    }}
                  />


                </div>
                <div>
                  <Tag
                    className="py-2 cursor-pointer bg-societe"
                    onClick={handleClickValid}
                  >
                    <FontAwesomeIcon icon={faPlus} style={{marginRight:"10px"}} /> Ajouter cet email comme
                    destinataire
                  </Tag>
                </div>
              </div>
            </div>

            {selectedEmailOptions?.length > 0 && (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <label htmlFor="objet">Email(s) ajoutés ({selectedEmailOptions.length})</label>
                  {selectedEmailOptions.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={handleRemoveAllRecipients}
                      title="Supprimer tous les destinataires"
                      style ={{marginRight:"10px",marginBottom:"10px"}}
                    >
                      <FontAwesomeIcon icon={faEraser} className="me-1" />
                      Tout supprimer
                    </button>
                  )}
                </div>
                <div className="mb-3 form-control" style={{ maxHeight: "100px", overflowY: 'auto' }}>
                  {selectedEmailOptions?.map((email, index) => (
                    <span key={index} style={{ display: "inline-block" }}>
                      <Tag>
                        {email.label}{" "}
                        {
                          <FontAwesomeIcon
                            className="cursor-pointer"
                            icon={faTimes}
                            onClick={() => {
                              setSelectedEmailOptions((prev) =>
                                prev.filter((_, i) => i !== index)
                              );
                            }}
                          />
                        }
                      </Tag>
                    </span>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="rich">
            <SummernoteEditor
              value={editorHtml}
              onChange={(content) => setEditorHtml(content)}
            />


          </div>
          <div className="row form-row">
            <div className="col-md-6" style={{ marginTop: "150px" }}>
{/* cover image / HTML import */}
<div className="d-flex flex-column me-4">
  <div className="mb-3">
    <input
      type="file"
      accept="image/*"
      onChange={handleCoverImageChange}
      style={{ display: "none" }}
      ref={coverImageInputRef}
    />
    <input
      type="file"
      accept=".html,.htm"
      style={{ display: "none" }}
      ref={htmlInputRef}
      onChange={handleHtmlImport}
    />

    {/* Dropdown pour choisir l'action */}
    <div className="select-wrapper">
      <select
        className="form-select responsive-select"
        onChange={(e) => {
          if (e.target.value === "coverImage") {
            coverImageInputRef.current?.click();
          } else if (e.target.value === "html") {
            htmlInputRef.current?.click();
          }
          e.target.value = ""; // reset la sélection
        }}
      >
        <option value="" disabled selected>
          Choisir une action
        </option>
        <option value="coverImage">
          Image de couverture - Newsletter (JPEG, PNG)
        </option>
        <option value="html">Ajouter un Newsletter HTML</option>
      </select>
    </div>
  </div>

  {/* Affichage du fichier HTML importé */}
    {importedHtml.name && (
      <div className="mb-3">
        <div className="d-flex align-items-center p-2 border rounded bg-light">
          <FontAwesomeIcon icon={faFile} className="me-2 text-primary" />
          <span className="flex-grow-1">{importedHtml.name}</span>
          <button
            type="button"
            className="btn btn-sm btn-outline-danger ms-2"
            onClick={handleRemoveHtml}
            title="Supprimer le fichier HTML"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
          <span className="text-success ms-2">
            <FaCheckCircle />
          </span>
        </div>
      </div>
    )}

  {/* Sélecteur de couleur pour l'en-tête */}
    <div className="mb-4">
      <div className="d-flex align-items-center mb-2">
        <label className="form-label me-2 mb-0">Couleur de l'en-tête</label>
        <FontAwesomeIcon 
          icon={faInfoCircle} 
          title="Choisissez la couleur de fond de l'en-tête de l'email" 
          style={{ color: '#2A919D', cursor: 'pointer' }} 
        />
      </div>
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <input
          type="color"
          className="form-control form-control-color"
          value={headerColor}
          onChange={(e) => handleColorChange(e.target.value)}
          style={{ width: '60px', height: '38px', padding: '4px' }}
          title="Choisir une couleur"
        />
        <input
          type="text"
          className="form-control"
          value={headerColor}
          onChange={(e) => handleColorChange(e.target.value)}
          placeholder="#2A919D"
          style={{ width: '120px' }}
          pattern="^#[0-9A-Fa-f]{6}$"
        />
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => handleColorChange("#2A919D")}
          style={{ fontSize: '0.9rem' }}
        >
          Réinitialiser
        </button>
        {lastUsedColor && lastUsedColor !== "#2A919D" && (
          <button
            type="button"
            className="btn btn-outline-info"
            onClick={() => handleColorChange(lastUsedColor)}
            style={{ fontSize: '0.9rem' }}
          >
            <FontAwesomeIcon icon={faHistory} className="me-1" />
            Dernière couleur utilisée
          </button>
        )}
      </div>
    </div>

  {/* Preview cover image */}
  <div className="attachment-cover-image ms-4">
    {attachments.coverImage && (
      <div className="attachment-item d-flex align-items-center">
        <span className="attachment-name">
          <img
            src={attachments.coverImage.preview}
            alt="Cover Preview"
            style={{
              width: "100px",
              height: "100px",
              objectFit: "cover",
              marginRight: "10px",
            }}
          />
        </span>
        <span
          className="cursor-pointer text-danger ms-2"
          onClick={() => handleRemoveCoverImage()}
        >
          {<FontAwesomeIcon icon={faTrash} />}
        </span>
      </div>
    )}
  </div>
</div>
            </div>


            <div className="col-md-6">
              {/* attachments */}
              <div className="d-flex flex-column mb-2">
                <div className="mb-3">
                  <input
                    type="file"
                    accept="*"
                    multiple
                    onChange={handleAttachmentChange}
                    style={{ display: "none" }}
                    ref={attachmentInputRef}
                  />
                  <div>
                    <Tag
                      className="py-2 cursor-pointer"
                      onClick={() => attachmentInputRef.current?.click()} // Trigger file input
                      // style={{ marginTop: "150px" }}
                    >
                      <FontAwesomeIcon icon={faPaperclip} /> Pièces jointes
                    </Tag>
                  </div>
                </div>

                <div className="attachments-list">
                  {attachments?.attachments?.map((file, index) => (
                    <div
                      key={index}
                      className="attachment-item d-flex align-items-center"
                    >
                      <span className="attachment-name">{file.name}</span>
                      <span
                        className="cursor-pointer text-danger ms-2"
                        onClick={() => handleRemoveAttachment(index)}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column w-100 justify-content-end" style={{ gap: "10px" }}>
            {loading && (
              <div className="alert alert-info w-100 mb-3">
                <span style={{ textAlign: "center", fontSize: "1.2rem", display: "block" }}>
                  Merci de patienter, l'envoi de l’email peut prendre un peu de temps en raison de la taille des pièces jointes ou du nombre de destinataires. Merci de votre compréhension et bonne continuation.
                </span>
              </div>
            )}
            <div className="d-flex justify-content-end w-100" style={{ gap: "10px" }}>
              <button
                type="button"
                style={{ backgroundColor: "#2A919D", color: "#fff", border: "none" }}
                onClick={() => {
                  const newValue = !allowUnsubscribe;
                  if (!newValue) {
                    setShowRgpdWarning(true);
                  }
                  setAllowUnsubscribe(newValue);
                }}
              >
                <FontAwesomeIcon icon={faBellSlash} className="me-2" />
                Pouvoir se désabonner
              </button>
              <button
                type="submit"
                disabled={loading}
                className="btn btn-primary"
                id="envoy"
              >
                {loading ? "Envoi..." : "Envoyer"}
              </button>
            </div>
          </div>
        </div>
      </form>
      <ToastContainer />
    </>
  );
}

export default EnvoyerMail;
